module.exports = __webpack_public_path__ + "static/media/musig_nano.wasm.2b1bfbe8.b64";